interface AnalysisData {
  title?: string;
  description?: string;
}

export const DEFAULT_SHARED_LINK_TITLE = 'Drama Analysis - DramaDetector';
export const DEFAULT_SHARED_LINK_DESCRIPTION =
  'Public drama analysis with score, likely impact, and summary from DramaDetector.';

export function getSharedLinkMeta(analysisData: AnalysisData | null) {
  return {
    title: analysisData?.title || DEFAULT_SHARED_LINK_TITLE,
    description: analysisData?.description || DEFAULT_SHARED_LINK_DESCRIPTION,
  };
}
